<template>
  <aside class="education-details-sidebar">
    <div class="education-details-sidebar__card"
         uk-sticky="top: 90; media: @m; bottom: true"
    >
      <div class="education-details-sidebar__media">
        <img :alt="item.name || ''" :src="item.cover_image_link"/>
      </div>

      <div class="education-details-sidebar__body">
        <div v-if="item.discount_codes"
             class="bg-gradient-danger shadow-danger uk-light uk-alert education-details-sidebar__discount"
             uk-alert
        >
          <a class="uk-alert-close uk-icon uk-close" uk-close></a>
          <p>{{ item.discount_codes }}</p>
        </div>

        <button id="btn-requestlist"
                class="btn btn-secondary transition-3d-hover education-details-sidebar__button"
                type="button"
                @click="$emit('show-requests')"
        >
          <i aria-hidden="true" class="uil-bell"></i>
          <span>
            {{ $t("general.requesters_list") }}
            ({{ item.users_pending_requests || 0 }})
          </span>
        </button>

        <button :disabled="requestNumber === 0 || Number(item.price) === 0"
                class="btn btn-success transition-3d-hover education-details-sidebar__button"
                type="button"
                @click="$emit('purchase')"
        >
          <i aria-hidden="true" class="uil-shopping-basket"></i>
          <span>{{ $t("general.send_purchase_request") }}</span>
        </button>
      </div>
    </div>

    <div id="message_modal_user" class="uk-flex-top" uk-modal>
      <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
        <div class="uk-modal-header pl-0">
          <h2 class="uk-modal-title">{{ $t("general.send_message") }}</h2>
          <button class="uk-modal-close-default"
                  type="button"
                  uk-close
          ></button>
        </div>
        <div class="uk-modal-body pl-0 pr-0">
          <textarea id="content_message"
                    :placeholder="$t('general.your_message')"
                    :value="message"
                    class="form-control"
                    name="content"
                    @input="$emit('update:message', $event.target.value)"
          ></textarea>
        </div>
        <div class="uk-modal-footer pl-0 pr-0 d-flex justify-content-end">
          <button class="uk-button uk-button-primary small"
                  type="button"
                  @click="$emit('send-message')"
          >
            <i aria-hidden="true" class="icon-feather-arrow-right"></i>
            {{ $t("general.send") }}
          </button>
        </div>
      </div>
    </div>

    <div id="modal-request-list" class="uk-modal" uk-modal>
      <div class="uk-modal-dialog">
        <button class="uk-modal-close-default uk-icon uk-close"
                type="button"
                uk-close
        ></button>
        <div class="uk-modal-header">
          <h2 class="uk-modal-title">{{ $t("general.requesting_users") }}</h2>
        </div>

        <div class="uk-modal-body pb-5 education-details-request-list">
          <div v-for="(request, index) in requests"
               :key="request.id || 'request_list_item_' + index"
               class="uk-grid-small uk-flex-middle position-relative uk-grid education-details-request-list__item"
               uk-grid
          >
            <div class="uk-width-auto position-relative">
              <img :alt="request.user.name || ''"
                   :src="request.user.photo_link"
                   class="rounded-circle avatar-sm"
              />
            </div>
            <div class="uk-width-expand">
              <p class="uk-text-truncate mb-0">
                <b>{{ request.user.name }} {{ request.user.surname }}</b>
              </p>
              <p>
                {{ $t("general.user_request_date") }}:
                {{ toDate(request.created_at) }}
              </p>
            </div>
            <div>
              <span aria-expanded="false" class="btn-option userlist">
                <i aria-hidden="true" class="icon-feather-more-vertical"></i>
              </span>
              <div
                  class="dropdown-option-nav uk-dropdown"
                  uk-dropdown="pos: bottom-right; mode: click"
              >
                <ul>
                  <li>
                    <button
                        type="button"
                        @click="$emit('show-user', request.user)"
                    >
                      <i aria-hidden="true" class="uil-user"></i>
                      {{ $t("general.examine_profile") }}
                    </button>
                  </li>
                  <li v-if="canSendMessage(request.user.id)">
                    <button type="button"
                            @click="$emit('show-message', request.user.id)"
                    >
                      <i aria-hidden="true" class="uil-envelope"></i>
                      {{ $t("general.send_message") }}
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </aside>
</template>

<script>
import moment from "moment";

export default {
  name: "EducationDetailsSidebar",
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    requestNumber: {
      type: Number,
      default: 0,
    },
    message: {
      type: String,
      default: "",
    },
    authUserId: {
      type: [Number, String],
      default: null,
    },
  },
  computed: {
    requests() {
      return Array.isArray(this.item.users_requests)
          ? this.item.users_requests.filter((request) => request && request.user)
          : [];
    },
  },
  methods: {
    canSendMessage(userId) {
      if (this.authUserId == null) return true;
      return String(userId) !== String(this.authUserId);
    },
    toDate(date) {
      return date ? moment(date).format("DD-MM-YYYY HH:mm:ss") : "-";
    },
  },
};
</script>

<style scoped>
.education-details-sidebar {
  min-width: 0;
}

.education-details-sidebar__card {
  overflow: hidden;
  margin: 0 !important;
  padding: 0;
  border: 1px solid var(--education-border);
  border-radius: 14px;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.08);
}

.education-details-sidebar__media {
  overflow: hidden;
  aspect-ratio: 16 / 9;
  background: #eef1f6;
}

.education-details-sidebar__media img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.education-details-sidebar__body {
  display: grid;
  gap: 12px;
  padding: 16px;
}

.education-details-sidebar__discount {
  margin: 0;
}

.education-details-sidebar__discount p {
  margin: 0;
}

.education-details-sidebar__button {
  display: inline-flex;
  width: 100%;
  min-height: 48px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin: 0;
  white-space: normal;
  touch-action: manipulation;
}

.education-details-sidebar__button:active:not(:disabled) {
  opacity: 0.85;
  transform: scale(0.98);
}

.education-details-request-list {
  min-height: 40vh;
  max-height: 80vh;
  overflow-y: auto;
}

.education-details-request-list__item + .education-details-request-list__item {
  margin-top: 12px;
}

.dropdown-option-nav button {
  width: 100%;
  padding: 8px 12px;
  border: 0;
  background: transparent;
  color: inherit;
  text-align: left;
  cursor: pointer;
}

.bg-gradient-danger {
  background: linear-gradient(50deg, #ff5630, #ff9430) !important;
}

@media (max-width: 959px) {
  .education-details-sidebar__card {
    position: static !important;
  }
}

@media (max-width: 767px) {
  .education-details-sidebar__card {
    display: grid;
    grid-template-columns: minmax(120px, 160px) minmax(0, 1fr);
  }

  .education-details-sidebar__media {
    height: 100%;
    min-height: 180px;
    aspect-ratio: auto;
  }

  #modal-request-list .uk-modal-dialog,
  #message_modal_user .uk-modal-dialog {
    width: calc(100% - 32px);
  }
}

@media (max-width: 479px) {
  .education-details-sidebar__card {
    display: block;
  }

  .education-details-sidebar__media {
    min-height: 0;
    aspect-ratio: 16 / 9;
  }
}

@media (prefers-reduced-motion: reduce) {
  .education-details-sidebar__button {
    transition: none;
  }
}
</style>
